import { normalizeHttpUrl } from './source-url.js';

/**
 * A scheme other than http(s) — `ftp:`, `file:`, `javascript:` — but not a `host:port`.
 * Without this, adding the missing scheme would quietly turn `ftp://x` into a valid URL.
 */
const NON_HTTP_SCHEME_RE = /^[a-z][a-z0-9+.-]*:(?!\d)/i;

export interface ParsedImportUrls {
  /** Normalized, de-duplicated URLs in the order they were entered. */
  urls: string[];
  /** Lines that are not URLs at all, reported back rather than silently dropped. */
  invalid: string[];
}

/**
 * Read a batch of recipe URLs typed one per line.
 *
 * Blank lines are ignored, a missing scheme is filled in, and a repeated URL is only
 * imported once — a pasted list is rarely as tidy as the box makes it look.
 */
export function parseImportUrls(input: string): ParsedImportUrls {
  const urls: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();

  for (const rawLine of input.split('\n')) {
    const line = rawLine.trim();
    if (line === '') continue;

    const hasHttpScheme = /^https?:\/\//i.test(line);
    const normalized =
      !hasHttpScheme && NON_HTTP_SCHEME_RE.test(line) ? null : normalizeHttpUrl(line);
    if (normalized == null) {
      invalid.push(line);
      continue;
    }
    if (seen.has(normalized)) continue;
    seen.add(normalized);
    urls.push(normalized);
  }

  return { urls, invalid };
}
